import DealBody from '@/finsight/ui/components/deals/DealListTable/components/DealBody';
import { getRatingsMapping as getRatingsMappingHelper } from '@/finsight/ui/common/helpers';
import keyResolver from '@/Framework/dataHelpers/keyResolver';
import { useDictionariesContext } from '@/finsight/application/Dictionaries/DictionariesContext';
import IRatingsMapping from '@/finsight/domain/vo/IRatingsMapping';
import memoize from '@/Framework/dataHelpers/memoize';
import type IDeal from '@/finsight/domain/vo/IDeal';

const getRatingsMapping = memoize((deal: IDeal, ratingAgenciesMapping) => {
  if (!deal || Object.keys(ratingAgenciesMapping).length === 0) {
    return [];
  }

  let ratingAgenciesForRegion = ratingAgenciesMapping[deal.product.id][deal.country.region.id];

  return getRatingsMappingHelper(deal.tranches, ratingAgenciesForRegion);
}, keyResolver);

export const DealData = ({
  rowData,
  showDealDetailsByDefault,
}: {
  rowData: IDeal,
  showDealDetailsByDefault: boolean,
}) => {
  const { ratingAgenciesMap } = useDictionariesContext();
  const ratingsMapping: IRatingsMapping = getRatingsMapping(rowData, ratingAgenciesMap);

  return (
    <DealBody
      deal={ rowData }
      showDealDetailsByDefault={ showDealDetailsByDefault }
      ratingsMapping={ ratingsMapping }
    />
  );
};
